import React from "react";
import { useIntl } from "react-intl";
import { RiCloseLine, RiDeleteBin2Line } from "react-icons/ri";

import CustomModal from "../../../../components/CustomModal";

import {
  Container,
  Header,
  Title,
  CloseButton,
  Description,
  Footer,
  CancelButton,
  DeleteButton,
} from "./styles";

const DeleteAssociationModal = ({
  id,
  open,
  handleClose,
  providerName,
  confirmation,
}) => {
  const intl = useIntl();

  const handleConfirm = () => {
    handleClose();
    confirmation();
  };

  return (
    <CustomModal id={id} isModalVisible={open} handleClose={handleClose}>
      <Container>
        <Header>
          <Title>
            {intl.formatMessage({ id: "delete_association_confirmation_title" })}
          </Title>
          <CloseButton type="button" onClick={handleClose}>
            <RiCloseLine size={20} />
          </CloseButton>
        </Header>

        <Description>
          <strong>{providerName}</strong>{" "}
          {intl.formatMessage({ id: "delete_association_confirmation_message" })}
          <br />
          {intl.formatMessage({ id: "cancel_order_irreversible" })}
        </Description>

        <Footer>
          <CancelButton type="button" onClick={handleClose}>
            {intl.formatMessage({ id: "cancel" })}
          </CancelButton>
          <DeleteButton type="button" onClick={handleConfirm}>
            <RiDeleteBin2Line size={16} />
            {intl.formatMessage({ id: "delete" })}
          </DeleteButton>
        </Footer>
      </Container>
    </CustomModal>
  );
};

export default DeleteAssociationModal;
